const COLORS = {
    PRIMARY: "#0b3c5d",
    SECONDARY: "#328bc3",
    GOLD: "#d9b310",
    SEMI_BLACK: "#1e2631",
    LIGHT_GRAY: '#9293b1',
    ERROR: '#d32f2f'
  };

export default {
    COLORS
}